import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackUsuarioComponent } from './feedback-usuario.component';

@NgModule({
  declarations: [FeedbackUsuarioComponent],
  imports: [FormsModule, CommonModule, NgbModule],
  exports: [FeedbackUsuarioComponent],
})
export class FeedbackUsuarioModule {}
